export const REGIONS = {
  mainland: "86",
  hongkong: "852",
  macao: "853",
  taiwan: "886",
  singapore: "0065",
  malaysia: "0060",
};

export const MobileAreaCodeList = [
  { label: "中国", code: REGIONS.mainland },
  { label: "中国香港", code: REGIONS.hongkong },
];

export const META_DATA = {
  area: AREA,
  projectName: PROJECT_NAME,
  language: LANGUAGE,
};

export enum ELang {
  hk = "zh_HK",
  ml = "zh_CN",
}

export const PHONE_PATTERN = /^1[3456789]\d{9}$/;
export const PHONE_PATTERN_HK = /^([569]\d{7}|188\d{5})$/; // 香港手机号/虚拟号： 9或6或588开头的8位数字

export enum ERound {
  single = "single",
  multiple = "multiple",
}

// tab value 顶部菜单key
export enum ETabMenuValue {
  chat = "chat", // 商量
  assistant = "assistantSquare", // 助手
  buddy = "buddySquare", // 伙伴
  discover = "discover", // 发现
  character = "character", // 角色
}

// 性别
export enum EGender {
  male = "male",
  female = "female",
}

// APP 下载 url
export enum EAppURL {
  ios_ml = "",
  android_ml = "",
  ios_hk = "https://apps.apple.com/app/id6483941793",
  android_hk = "https://play.google.com/store/apps/details?id=com.sensetime.chat",
}

// 不上报友盟性能平台的异常
export const UMENG_IGNORE_ERRORS: string[] = [
  "The user aborted a request.", // 聊天停止生成
];

// 最大视频对话数,相当于不限制数量了
export const MAX_VIDEO_SESSION_NUM = 50000000;
